import React from 'react';

interface StatsCardProps {
  label: string;
  value: number | string;
  icon: React.ReactNode;
  color: string;
  lightColor: string;
  trend?: string;
}

const StatsCard: React.FC<StatsCardProps> = ({ label, value, icon, color, lightColor, trend }) => (
  <div className="card" style={{
    padding: '20px',
    flex: 1,
    minWidth: '160px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    transition: 'box-shadow .15s, transform .15s',
  }}
    onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
    onMouseLeave={(e) => { e.currentTarget.style.boxShadow = ''; e.currentTarget.style.transform = ''; }}
  >
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
      <div style={{
        width: 40, height: 40,
        background: lightColor,
        borderRadius: '10px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: color,
        flexShrink: 0,
      }}>
        {icon}
      </div>
      {trend && (
        <span style={{ fontSize: '11px', color: '#10b981', fontWeight: 600, background: '#d1fae5', borderRadius: '20px', padding: '2px 8px' }}>
          {trend}
        </span>
      )}
    </div>
    <div>
      <div style={{ fontSize: '28px', fontWeight: 800, color: '#0f172a', lineHeight: 1 }}>{value}</div>
      <div style={{ fontSize: '12px', color: 'var(--text-3)', marginTop: '4px', fontWeight: 500 }}>{label}</div>
    </div>
  </div>
);

export default StatsCard;
